import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";
import { STATS, IMAGES as CI } from "../content/siteContent";
import { locStat } from "../content/i18n_extra";
import { KanjiWatermark } from "./JapaneseMotifs";
const STATS_BG = CI.statsbg;

export function StatsBand() {
  const { t, lang } = useLang();

  return (
    <section className="relative bg-deepsea py-24 sm:py-28 overflow-hidden" data-testid="stats-section">
      <KanjiWatermark text="科学" light className="left-4 top-4 text-[10rem] hidden lg:block" />
      <img src={STATS_BG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-[0.08] pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }}>
          <div className="text-xs font-heading font-bold tracking-[0.3em] uppercase text-aqua mb-4">{t("sec_stats_kicker")}</div>
          <h2 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-white text-balance max-w-2xl">{t("sec_stats_title")}</h2>
        </motion.div>
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-10">
          {STATS.map((s, i) => (
            <motion.div
              key={i}
              data-testid={`stat-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.08 }}
              className="border-t border-white/15 pt-5"
            >
              <div className="font-heading text-4xl sm:text-5xl font-bold text-aqua tracking-tight">{s.v}</div>
              <p className="mt-3 text-sm text-white/60 leading-relaxed">{locStat(s, i, lang)}</p>
            </motion.div>
          ))}
        </div>
        <p className="mt-10 text-[11px] text-white/35">{t("stats_note")}</p>
      </div>
    </section>
  );
}
